/* eslint-disable @typescript-eslint/no-require-imports */
import CustomPlatform from "$src/core/utils/platform/platform";

// eslint-disable-next-line no-restricted-imports
import type { ExpoTvConnectHostModule as ExpoTvConnectHostModuleClass } from "./src/ExpoTvConnectHost.types";

// eslint-disable-next-line no-restricted-imports
export * from "./src/ExpoTvConnectHost.types";

export const ExpoTvConnectHostModule = CustomPlatform.select<
  () => ExpoTvConnectHostModuleClass
>({
  tv: () => require("./src/ExpoTvConnectHostModule.tv").default,
  default: () => require("./src/ExpoTvConnectHostModule").default,
})();
